import { useState } from "react";

export default function SendWhatsApp() {
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");

  const sendMessage = async () => {
    const res = await fetch("https://crm.semicoloninnovations.in/api/send-message.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        phone,
        name,
        date: "31 Dec 2025"
      }),
    });

    const data = await res.json();
    alert("Message Sent");
    console.log(data);
  };

  return (
    <div style={{ maxWidth: 400 }}>
      <h3>Send WhatsApp Offer</h3>

      <input
        placeholder="Phone"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
      />

      <input
        placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      <button onClick={sendMessage}>
        Send WhatsApp
      </button>
    </div>
  );
}
